import { cn } from '@/lib/utils'
import { KinkUpLogo } from '@/components/brand/KinkUpLogo'

interface LoadingScreenProps {
  message?: string
  className?: string
}

export function LoadingScreen_M10_11({ message, className }: LoadingScreenProps) {
  return (
    <div className={cn('flex min-h-screen items-center justify-center bg-background', className)}>
      {/* Background ambient */}
      <div className="absolute top-[-20%] left-[-10%] h-[400px] w-[400px] rounded-full bg-primary/6 blur-[120px] animate-glow-pulse" />
      <div className="absolute bottom-[-15%] right-[-5%] h-[300px] w-[300px] rounded-full bg-secondary/4 blur-[100px] animate-glow-pulse" style={{ animationDelay: '1.5s' }} />

      <div className="relative flex flex-col items-center gap-6 animate-fade-in">
        {/* Pulsing logo container */}
        <div className="relative">
          <div className="absolute inset-0 rounded-2xl bg-primary/20 blur-xl animate-glow-pulse" />
          <div className="relative h-16 w-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20 flex items-center justify-center">
            <KinkUpLogo size={34} animated />
          </div>
        </div>

        {/* Shimmer bar */}
        <div className="w-32 h-0.5 rounded-full bg-muted overflow-hidden">
          <div className="h-full w-1/3 rounded-full bg-gradient-to-r from-transparent via-primary to-transparent shimmer" />
        </div>

        {message && (
          <p className="text-xs text-muted-foreground/60 tracking-wider uppercase">{message}</p>
        )}
      </div>
    </div>
  )
}
